/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Similar_TitleInputs */

const en_us2_exercise_sheet_similar_title = /** @type {(inputs: Exercise_Sheet_Similar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Similar exercises`)
};

const pt_br2_exercise_sheet_similar_title = /** @type {(inputs: Exercise_Sheet_Similar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios parecidos`)
};

const es_419_exercise_sheet_similar_title = /** @type {(inputs: Exercise_Sheet_Similar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios similares`)
};

const pt_pt2_exercise_sheet_similar_title = /** @type {(inputs: Exercise_Sheet_Similar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios semelhantes`)
};

const fr_fr2_exercise_sheet_similar_title = /** @type {(inputs: Exercise_Sheet_Similar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices similaires`)
};

const de_de2_exercise_sheet_similar_title = /** @type {(inputs: Exercise_Sheet_Similar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ähnliche Übungen`)
};

const it_it2_exercise_sheet_similar_title = /** @type {(inputs: Exercise_Sheet_Similar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi simili`)
};

/**
* | output |
* | --- |
* | "Similar exercises" |
*
* @param {Exercise_Sheet_Similar_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_similar_title = /** @type {((inputs?: Exercise_Sheet_Similar_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Similar_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_similar_title(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_similar_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_similar_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_similar_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_similar_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_similar_title(inputs)
	return en_us2_exercise_sheet_similar_title(inputs)
});
export { exercise_sheet_similar_title as "exercise-sheet.similar_title" }